import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'

type LeaveMultiCartResponse = paths['/api/carts/multi-carts/{multiCartId}/users/leave']['delete']['responses']['204']['content']['application/json']

export function leaveMultiCart(multiCartId: string) {
  return request.delete<LeaveMultiCartResponse>(`/api/carts/multi-carts/${multiCartId}/users/leave`, { credentials: 'include' })
}
